import { notifications } from '@mantine/notifications';
import { IconExclamationCircle } from '@tabler/icons-react';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { Endpoints } from '@xver/apis';
import { CreateChargeData, CreateChargeResponse } from '@xver/@types/charge';
import { getErrorMessage } from '@xver/utils/error';

export function useCreateChargeMutation() {
    const { t } = useTranslation('topup');

    return useMutation<CreateChargeResponse, unknown, CreateChargeData>({
        mutationFn: (payload) => Endpoints.v1.Charges.createCharge(payload),
        onError: (err) => {
            notifications.show({
                title: t('toast.errorTitle'),
                message: getErrorMessage(err) ?? t('toast.errorMessage'),
                icon: <IconExclamationCircle size={18} color="#eb5757" />,
            });
        },
    });
}
